"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reducer_builder_1 = require("./reducer-builder");
exports.createReducer = function (initial, cases) {
    var builder = new reducer_builder_1.ReducerBuilder().init(initial);
    Object.keys(cases).forEach(function (type) { return builder.case(type, cases[type]); });
    return builder.build();
};
//# sourceMappingURL=create-reducer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngfk/ts-redux/dist/create-reducer.js
// module id = 103
// module chunks = 0